/**
 * This custom hook provides the functionality to create a course with the given parameters.
 */

import {useContext, useState} from "react";
import {useHistory} from "react-router-dom";
import {useSnackbar} from "notistack";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import {useIntl} from "react-intl";

const useCreateCourse = () => {
    const [saveInProgress, setSaveInProgress] = useState(false)

    const {signedInUser} = useContext(FirebaseAuthContext);
    const history = useHistory();

    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();


    const create = async (courseData) => {
        setSaveInProgress(true)

        const idToken = await signedInUser.getIdToken()
        return fetch('/reg-main/courses', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                idToken: idToken,
                courseData: {
                    name: courseData.name,
                    fromDate: courseData.fromDate,
                    toDate: courseData.toDate,
                    association: courseData.association,
                    disciplines: courseData.disciplines,
                    participants: courseData.participants.map((user) => user.uid),
                    playlists: courseData.playlists.map((playlist) => playlist.key),
                    open: courseData.open
                }
            })
        }).then(async (data) => {
            // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
            if (data.status !== 200) {
                throw new Error((await data.json()).status)
            }

            enqueueSnackbar(
                intl.formatMessage({
                    id: 'app.courses.messages.new.success',
                    defaultMessage: 'Course {name} created.'
                }, {name: courseData.name}), {
                    variant: 'success',
                    preventDuplicate: true,
                    autoHideDuration: 3000
                });
            history.push("/admin/courses");
        }).catch((error) => {
            enqueueSnackbar(
                intl.formatMessage({
                    id: 'app.courses.messages.new.error',
                    defaultMessage: 'Something went wrong while creating the course: {error}'
                }, {error: error.message}), {
                    variant: 'error',
                    preventDuplicate: true,
                    autoHideDuration: 5000
                });
        }).finally(() => {
            setSaveInProgress(false)
        })
    }

    const cancel = () => {
        history.push("/admin/courses");
    }

    return {create, saveInProgress, cancel}
}
export default useCreateCourse;